import { TranslateService } from '@ngx-translate/core';
import { ConfigInitializer } from '@spartacus/core';
import { firstValueFrom, map } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class I18nConfigInitializer implements ConfigInitializer {
  scopes = ['i18n.resources'];

  constructor(private translateService: TranslateService) {}

  configFactory(): Promise<any> {
    return firstValueFrom(
      this.translateService.onLangChange.pipe(
        map(() => ({
          i18n: {
            resources: Object.fromEntries(
              Object.entries(this.translateService.translations).map(([key, value]) => [
                key, { skipLink: { skipLink: value.skipLink } }
              ])
            )
          }
        }))
      )
    );
  }
}
